export default __webpack_public_path__ + "static/media/postSuvinil4.883aee28.gif";